// Main initialiser

( function( $, window, document, undefined ) {

	( function() {

		/**
		 * Scroll to a hash on the page.
		 * Will check scrollify named sections if the plugin exists.
		 * @param  {String} hash A hash string to scroll to. Should include the # character at the start.
		 */
		let scrollToHash = function(hash) {
      // Figure out element to scroll to
      var $target = $(hash);
      $target = $target.length ? $target : $('[name=' + hash.slice(1) + ']');
      // Does a scroll target exist?
      if ($target.length) {
        window.SmoothScroll.toElement( $target );
      } else {

      	let $altTarget = $(`[data-section-name="${ hash.replace( /#/, '' ) }"]`);

      	if ( $altTarget.length ) {
      		if ( $('body').hasClass('scrollify-initialised') ) {
	      		$.scrollify.move( hash );
	      	} else {
		        window.SmoothScroll.toElement( $altTarget );
	      	}
      	}

      }
		};
		
		/**
		 * Smooth scroll anchors starting with a hash.
		 */
		$('a[href*="#"]')
		  // Remove links that don't actually link to anything
		  .not('[href="#"]')
		  .not('[href="#0"]')
		  .click(function(event) {
		    // On-page links
		    if (
		      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
		      location.hostname == this.hostname
		    ) {
		    	scrollToHash( this.hash );
		    }
		  });

		  /**
		   * Smooth scroll logo to top of page, if on home page
		   */
		  $('.js-logo').click( (event) => {
		  	if ( $('body').hasClass('home') ) {

		  		if ( window.scrollifyController.isInitialised() ) {
			  		// Explicit hash of first section
			  		scrollToHash( '#shopping' );
		  		} else {
		  			window.SmoothScroll.toPosition(0);
		  		}

		  		if ( window.navigationController.isOpen() ) {
		  			window.navigationController.close();
		  		}

		  		event.preventDefault();
		  		return false;
		  	}
		  } );
				
	} )();


	// Listen for hash changes and act accordingly
	( function() {
		
		window.onhashchange = () => {
			if ( location.hash ) {

		    if ( $('body').hasClass('scrollify-initialised') && $(`[data-section-name="${ location.hash.slice(1) }"]`).length ) {
		    	$.scrollify.move( location.hash, true );
		    }

			}
		};

	} )();

	// Check if navigation has overflow and toggle class
	( function() {
		let $possibleOverflowElements = $('.js-header-inner'),
				isOverflown = (element) => {
			    return (
			    	element.scrollHeight > element.clientHeight || 
			    	element.scrollWidth > element.clientWidth
		    	);
				},

				setClass = () => {
					if ( $possibleOverflowElements.length ) {
						$possibleOverflowElements.each( (index, element) => {
							let $element = $(element);
							$element.toggleClass( 'is-overflown', isOverflown( $element.get(0) ) );
						} );
					}
				};

		setClass();
		$(window).resize( setClass );
		$(document).on( 'menu-drawer-changed-state', setClass );
	} )();


	// Toggle submenu drawers within main navigation
	( function() {
		
		let $drawers = $('.js-menu-drawer');				

		let DrawerEventController = ( function() {

			/**
			 * Get (or create) the singleton controller for a drawer.
			 * The class will be stored onto the element.
			 * @param  {jQuery} $drawer A jQuery element represeting a menu drawer.
			 * @return {MenuDrawerController}
			 */
			function _getController( $drawer ) {
				let controller;

				if ( $drawer.get(0).drawerController ) {
					controller = $drawer.get(0).drawerController;
				} else {
					controller = new MenuDrawerController( $drawer, $drawer.find('.js-menu-drawer__toggle'), $drawer.find('.submenu') );
					$drawer.get(0).drawerController = controller;
				}
				
				return controller;
			}

			/**
			 * Close the currently open (active) drawer.
			 */
			function closeActive() {
				let $activeDrawer = $drawers.filter('.is-open'),
						drawerController;

				if ( $activeDrawer.length ) {
					drawerController = _getController( $activeDrawer );
					drawerController.close();
				}
			}

			/**
			 * Open a specific drawer.
			 * @param  {jQuery} $drawer a jQuery element represeting a menu drawer.
			 */
			function open( $drawer ) {
				let drawerController = _getController( $drawer );

				drawerController.open();
			}

			/**
			 * Close a specific drawer.
			 * @param  {jQuery} $drawer a jQuery element represeting a menu drawer.
			 */
			function close( $drawer ) {
				let drawerController = _getController( $drawer );

				drawerController.close();
			}

			/**
			 * Open or close a specific drawer.
			 * @param  {jQuery} $drawer a jQuery element represeting a menu drawer.
			 */
			function toggle( $drawer ) {
				let drawerController = _getController( $drawer );

				drawerController.toggle();
			}

			return {
				closeActive,
				open,
				close,
				toggle
			};

		} )();

		$('.js-menu-drawer__toggle').click( (event) => {

			let $target = $(event.target);

			if ( !$target.is('.js-menu-drawer__toggle') ) {
				$target = $target.closest('.js-menu-drawer__toggle');
			}

			DrawerEventController.closeActive();
			DrawerEventController.toggle( $target.closest('.js-menu-drawer') );

		} );

	} )();


	// Handle clicks on tenants and filters
	( function() {

		let $tenants = $('.js-tenant'),
				$filters = $('.js-filter-button');
		const supportsHistory = !!( window.history && window.history.pushState );

		if ( !$tenants.length || !$filters.length ) {
			return;
		}

		function disableActive() {
			$tenants.filter('.is-active')
				.removeClass('is-active')
				.find( '.tenant-grid-item__image' )
					.css( 'transform', '' );
		}

		$tenants.on( 'click mouseover', (event) => {
			let $this = $(event.target);

			if ( !$this.is('.js-tenant') ) {
				$this = $this.closest('.js-tenant');
			}

			disableActive();
			$this.addClass('is-active');

			let transform = 'translateY(-125px) translateY(50%) translateY(1em)';
					$image = $this.find( '.tenant-grid-item__image' );

			transform += `scale( ${ 70 / $image.outerHeight() } )`;
			$image.css( 'transform', transform );
		} );

		$tenants.on( 'mouseout', (event) => {
			disableActive();
		} );


		function filterTenants( value ) {
			if ( '*' == value ) {
				$tenants.show();
			} else {

				let $items = $(`.js-tenant[data-term="${value}"]`);

				if ( $items.length ) {
					$tenants.hide();
					$items.show();
				}
				
			}

			if ( supportsHistory ) {
				let pageUrl = getPageUrl();
				let url = addQueryArg( 'filter', value, pageUrl );
				
				if ( pageUrl !== url ) {
					window.history.pushState( { path: url }, '', url );
				}
			}
		}

		$filters.click( (event) => {
			let $this = $(event.target);
			const filter = $this.data('filter');

			filterTenants( filter );
		} );

		const onLoadFilter = getQueryArg( location.href, 'filter' );
		if ( onLoadFilter ) {
			filterTenants( onLoadFilter );
		}

		if ( supportsHistory ) {
			window.onpopstate = function( event ) {
				let filter = getQueryArg( location.href, 'filter' );

				if ( filter ) {
					filterTenants( filter );
				}
			};

			// Replace current page state on load with show all search
			if ( !onLoadFilter ) {
				let url = addQueryArg( 'filter', '*', getPageUrl() );
				window.history.replaceState( { path: url }, '', url );
			}
		}
		
	} )();


	// Fix object-fit display in non-supporting browsers
	( function() {
		
		let $objectFitImages = $('.polyfill-object-fit');

		if ( $objectFitImages.length && !Modernizr.objectfit ) {
			$objectFitImages.each( ( index, img ) => {
				let $img = $(img);

				$img.wrap( `<div style="background-image: url(${ $img.attr('src') });"></div>` );
				$img.parent().attr( 'class', $img.attr('class') );
				$img.removeAttr('class');

				$img.css( {
					visibility: 'hidden'
				} );
			} );
		}

	} )();


	// Set up match height plugin, only for IE
	( function() {
		
		if ( device.isIE ) {
			$('[data-ie-mh]').matchHeight();
			if ( window.scrollifyController ) {
				window.scrollifyController.update();
			}
		}

	} )();


	// Handle clicks to surface the search form if hidden within the menu
	( function() {

		let $searchTriggers = $('.js-show-search-form'),
				$searchForm = $('#search-form');

		$searchTriggers.click( (event) => {
			if ( $searchForm.length ) {
				if ( navigationController.isOpen() ) {
					$searchForm.find('input').focus();
					$searchForm.addClass( 'seek-attention' );
				} else {
					navigationController.open();

					setTimeout(function() {
						$searchForm.find('input').focus();
					}, 450);
				}

				setTimeout(function() {
					$searchForm.removeClass('seek-attention');
				}, 1000);
			}

			event.preventDefault();
			return false;
		} );
		
	} )();
	
} )( jQuery, window, document );
